export function validateEmail (value) {
    const length = value.length;
    if( length < 1 ) {
        return {
            value: value,
            isValid : false,
            message : "Error: Please enter an Email address."
        }
    } else if( length < 6 ) {
        return {
            value: value,
            isValid : false,
            message : "Error: Email Address must be at least six characters in length."
        }
    }
    else if (length > 45) {
        return {
            value: value,
            isValid : false,
            message : "Error: Email Address can not exceed 45 characters in length."
        }
    }
    else if (length >= 6 && length <= 45) {
      // const rfc2822 = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      // Unnecessary escape character: \"
      const rfc2822 = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      let emailMatches = rfc2822.test(value);

      if(!emailMatches) {
        return {
            value: value,
            isValid : false,
            message : "Error: Please enter a valid Email address."
          }          
      } else {
        return {
            value: value,
            isValid : true,
            message : ""
        }
      }
   }
}

export default validateEmail;


// WEBPACK FOOTER //
// ./src/helper/validateEmail.js